import React, { useEffect, useState, useRef } from "react";
import {
  Box,
  Button,
  Checkbox,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  IconButton,
  InputLabel,
  FormControl,
  MenuItem,
  Select,
  TextField,
  Typography,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  Pagination,
  PaginationItem,
  Grid,
} from "@mui/material";
import Autocomplete from "@mui/material/Autocomplete";
import { Add, Delete, Download, FilterList, MoreVert, Search, FirstPage, LastPage, Close, PhotoCamera, Remove } from "@mui/icons-material";
import CloudUploadIcon from "@mui/icons-material/CloudUpload";
import { TrashOutline } from "react-ionicons";
import "../../../shared/components/Item.css";
import MapPinLocation from "../../../shared/components/MapPinLocation.tsx";

import { useNavigate } from "react-router-dom";
import FormHelperText from "@mui/material/FormHelperText";
import { TimePicker } from '@mui/x-date-pickers/TimePicker';
import { LocalizationProvider, DesktopDatePicker } from "@mui/x-date-pickers";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import dayjs from 'dayjs';
import customParseFormat from 'dayjs/plugin/customParseFormat';

dayjs.extend(customParseFormat);

import { AttendanceSearchParams, getAttendances, createAttendance, uploadAttendancePhoto, editAttendance, fetchAttendancePhotoBlob, deleteAttendance } from "../services/attendanceService.tsx";
import { LocationSearchParams, getLocations, createLocation, editLocation, deleteLocation } from "../services/locationService.tsx";
import {
  getEmployees,
} from "../services/employeeService.tsx";
import Swal from "sweetalert2";
import * as XLSX from 'xlsx';

import {
  getAllOffices,
} from "../services/officeService.tsx";

import {
  getVendors,
} from "../services/vendorService.tsx";

const statusColors = {
  "Valid": "green",
  "Not Valid": "#f55",
  "Leave": "orange",
  "Inactive": "gray",
  "Active": "green"
};

const AttendanceListPage: React.FC = () => {
  const [selectedRows, setSelectedRows] = useState<number[]>([]);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [currentPage, setCurrentPage] = useState(1);
  const [showSearch, setShowSearch] = useState(false);
  const [searchQuery, setSearchQuery] = useState("");
  const [rows, setRows] = useState<any[]>([]);
  const [totalPages, setTotalPages] = useState(1);
  const [totalItems, setTotalItems] = useState(0); // Total semua data
  const [openDeleteDialog, setOpenDeleteDialog] = useState(false);
  const [openAddAttendanceDialog, setOpenAddAttendanceDialog] = useState(false);
  const [openAddItemDetailsDialog, setOpenAddItemDetailsDialog] = useState(false);

  const [officeOptions, setOfficeOptions] = useState([]);
  const [vendors, setVendors] = useState<{ [id: string]: string }>({});
  const [employees, setEmployees] = useState<{ [nik: string]: { name: string, company: string, employeeType: string } }>({});

  const [error, setError] = useState("");
  const [openFilterDialog, setOpenFilterDialog] = useState(false);
  const [filters, setFilters] = useState([{ field: "name", value: "" }]);

  const [isLoading, setIsLoading] = useState(true);
  const navigate = useNavigate();

  const [itemsToDelete, setItemsToDelete] = useState<any[]>([]);

  const fields = [
    { id: "photoCheckin", shown: "Check In" },
    { id: "photoCheckout", shown: "Check Out" },
    { id: "photoOvertimeIn", shown: "Overtime In" },
    { id: "photoOvertimeOut", shown: "Overtime Out" }
  ];

  const [choosenField, setChoosenField] = useState("");

  const [startDate, setStartDate] = useState<string | null>(null);
  const [endDate, setEndDate] = useState<string | null>(null);


  const offset = (currentPage - 1) * rowsPerPage;

  const [sortConfig, setSortConfig] = useState<{ orderBy: string; order: "asc" | "desc" }>({
    orderBy: "createdAt",
    order: "desc",
  });

  const handleSort = (column: string) => {
    setSortConfig((prev) => {
      if (prev.orderBy === column) {
        return {
          orderBy: column,
          order: prev.order === "asc" ? "desc" : "asc",
        };
      } else {
        return {
          orderBy: column,
          order: "asc",
        };
      }
    });
    setCurrentPage(1); // reset ke halaman 1 saat sort berubah
  };


  // Daftar pilihan filter yang tersedia
  const availableFilters = [
    { value: "nik", label: "NIK" },
    { value: "employeeName", label: "Employee Name" },
    { value: "attendanceStatus", label: "Attendance Status" },
    { value: "officeLocation", label: "Office Location" },
    { value: "vendorId", label: "Vendor" },
  ];

  const [filterDate, setFilterDate] = useState(dayjs().format("YYYY-MM-DD")); // default hari ini

  // Daftar pilihan filter yang tersedia
  const availableFiltersInit = [
    { value: "nik", label: "NIK" },
    { value: "employeeName", label: "Employee Name" },
    { value: "attendanceStatus", label: "Attendance Status" },
    { value: "officeLocation", label: "Office Location" },
    { value: "vendorId", label: "Vendor" },
  ];


  const [filterParams, setFilterParams] = useState<{
    keyword?: string;
    nik?: string;
    employeeName?: string;
    officeLocation?: string;
    vendorId?: string;
    attendanceStatus?: string;
    attendanceDate?: string;
    checkinTime?: string;
    checkoutTime?: string;
    workHours?: string;
    startDate?: string;
    endDate?: string;
  }>({});

  const displayedRows = rows.slice((currentPage - 1) * rowsPerPage, currentPage * rowsPerPage);

  const fetchOfficeList = async () => {
    try {
      const result = await getAllOffices();
      setOfficeOptions(result); // Simpan data office dari backend
    } catch (error) {
      console.error("Failed to fetch offices:", error);
    }
  };

  const fetchVendors = async () => {
    try {
      const result = await getVendors({ limit: 1000000 });
      const vendorMap: { [id: string]: string } = {};
      result.data?.forEach((emp) => {
        vendorMap[emp.id] =
          emp.vendorName
          ;
      });
      setVendors(result.data); // Simpan data office dari backend
    } catch (error) {
      console.error("Failed to fetch offices:", error);
    }
  };

  const getEmployee = async (nik = '') => {
    try {
      const result = await getEmployees({ nik: nik });

      if (result.data && result.data.length == 1) {
        return result.data[0].name;
      } else {
        return ""
      }


    } catch (error) {
      console.error("Failed to fetch employee:", error);
    }
  };

  const fetchEmployees = async () => {
    try {
      const result = await getEmployees({ limit: 1000000 });
      const employeeMap: { [nik: string]: { name: string, company: string, employeeType: string } } = {};

      const rsVendor = await getVendors({ limit: 1000000 });
      const vendorMap: { [id: string]: string } = {};
      await rsVendor.data?.forEach((emp) => {
        vendorMap[emp.vendorId] =
          emp.vendorName
          ;
      });
      setVendors(rsVendor.data); // Simpan data office dari backend




      await result.data?.forEach((emp) => {
        emp.company && emp.company !== "-" ? console.log(emp.name, emp.company, vendorMap[emp.company]) : null;
        employeeMap[emp.nik] = {
          name: emp.name,
          employeeType: emp.employeeType,
          company: vendorMap[emp.company] || '-',
        };
      });

      setEmployees(employeeMap);
    } catch (error) {
      console.error("Failed to fetch employee:", error);
    }
  };


  const fetchAttendances = async () => {
    setIsLoading(true);
    try {


      const result = await getAttendances({
        ...filterParams,
        limit: rowsPerPage,
        offset,
        orderBy: sortConfig.orderBy,
        order: sortConfig.order,
      });

      await result.data.map(async (attd) => { await console.log('In:', attd.overtimeIn, 'Out:', attd.overtimeOut); attd.overtimeHours = await calculateWorkHours(attd.overtimeIn, attd.overtimeOut) })

      await setRows(result.data);
      setTotalPages(result.pagination.totalPages);
      setTotalItems(result.total);
    } catch (err) {
      console.error(err);
    } finally {
      setIsLoading(false);
    }
  };

  // // Fetch data on mount
  // useEffect(() => {
  //   fetchVendors();
  //   // fetchAttendances();
  //   fetchOfficeList();
  //   fetchEmployees();
  // }, []);

  // Fetch data on mount
  useEffect(() => {
    // fetchVendors();
    fetchAttendances();
    fetchOfficeList();
    fetchEmployees();
  }, [currentPage, rowsPerPage, filterParams, sortConfig]);

  const [attendanceData, setAttendanceData] = useState<{
    officeLocation: string,
    nik: string,
    employeeName: string,
    company: string,
    employeeType: string,
    attendanceDate: string,
    checkinTime: string | null,
    checkoutTime: string | null,
    photoCheckin: string,
    photoCheckout: string,
    workHours: string,
    attendanceStatus: string,
    leaveType: string,
    leaveReason: string,
    overtimeIn: string | null,
    overtimeOut: string | null,
    overtimeHours: string,
    photoOvertimeIn: string,
    photoOvertimeOut: string,
    range: string,
    notes: string,
    fileCIn: File | null,
    fileCOut: File | null,
    fileOIn: File | null,
    fileOOut: File | null,
  }>({
    officeLocation: "",
    nik: "",
    employeeName: "",
    company: "",
    employeeType: "",
    attendanceDate: dayjs().format("YYYY-MM-DD"),
    checkinTime: null,
    checkoutTime: null,
    photoCheckin: "",
    photoCheckout: "",
    workHours: "",
    attendanceStatus: "",
    leaveType: "",
    leaveReason: "",
    overtimeIn: null,
    overtimeOut: null,
    overtimeHours: "",
    photoOvertimeIn: "",
    photoOvertimeOut: "",
    range: "",
    notes: "",
    fileCIn: null,
    fileCOut: null,
    fileOIn: null,
    fileOOut: null,
  });

  const [errors, setErrors] = useState({
    officeLocation: false,
    nik: false,
    employeeName: false,
    company: false,
    employeeType: false,
    attendanceDate: false,
    checkinTime: false,
    checkoutTime: false,
    photoCheckin: false,
    photoCheckout: false,
    workHours: false,
    attendanceStatus: false,
    leaveType: false,
    leaveReason: false,
    overtimeIn: false,
    overtimeOut: false,
    photoOvertimeIn: false,
    photoOvertimeOut: false,
    range: false,
    notes: false,
  });

  const [openEditAttendanceDialog, setOpenEditAttendanceDialog] = useState(false);
  const [isEditing, setIsEditing] = useState(false);
  const [editAttendanceData, setEditAttendanceData] = useState<{
    id: string,
    attendanceId: string,
    nik: string,
    officeLocation: string,
    employeeName: string,
    employeeType: string,
    company: string,
    attendanceDate: string,
    checkinTime: string | null,
    checkoutTime: string | null,
    photoCheckin: string,
    photoCheckout: string,
    workHours: string,
    attendanceStatus: string,
    leaveType: string,
    leaveReason: string,
    overtimeIn: string | null,
    overtimeOut: string | null,
    overtimeHours: string,
    photoOvertimeIn: string,
    photoOvertimeOut: string,
    range: string,
    notes: string,
    fileCIn: File | null;
    fileCOut: File | null;
    fileOIn: File | null;
    fileOOut: File | null;
    previewUrlCIn: string;
    previewUrlCOut: string;
    previewUrlOIn: string;
    previewUrlOOut: string;
  }>({
    id: "",
    attendanceId: "",
    nik: "",
    officeLocation: "",
    employeeName: "",
    company: "",
    employeeType: "",
    attendanceDate: "",
    checkinTime: null,
    checkoutTime: null,
    photoCheckin: "",
    photoCheckout: "",
    workHours: "",
    attendanceStatus: "",
    leaveType: "",
    leaveReason: "",
    overtimeIn: null,
    overtimeOut: null,
    overtimeHours: "",
    photoOvertimeIn: "",
    photoOvertimeOut: "",
    range: "",
    notes: "",
    fileCIn: null,
    fileCOut: null,
    fileOIn: null,
    fileOOut: null,
    previewUrlCIn: "",
    previewUrlCOut: "",
    previewUrlOIn: "",
    previewUrlOOut: "",
  });

  const [originalEditAttendanceData, setOriginalEditAttendanceData] = useState<{
    id: string,
    attendanceId: string,
    nik: string,
    officeLocation: string,
    employeeName: string,
    company: string,
    employeeType: string,
    attendanceDate: string,
    checkinTime: string,
    checkoutTime: string,
    photoCheckin: string,
    photoCheckout: string,
    workHours: string,
    attendanceStatus: string,
    leaveType: string,
    leaveReason: string,
    overtimeIn: string,
    overtimeOut: string,
    overtimeHours: string,
    photoOvertimeIn: string,
    photoOvertimeOut: string,
    range: string,
    notes: string,
    fileCIn: File | null;
    fileCOut: File | null;
    fileOIn: File | null;
    fileOOut: File | null;
    previewUrlCIn: string;
    previewUrlCOut: string;
    previewUrlOIn: string;
    previewUrlOOut: string;
  }>({
    id: "",
    attendanceId: "",
    nik: "",
    officeLocation: "",
    employeeName: "",
    company: "",
    employeeType: "",
    attendanceDate: "",
    checkinTime: "",
    checkoutTime: "",
    photoCheckin: "",
    photoCheckout: "",
    workHours: "",
    attendanceStatus: "",
    leaveType: "",
    leaveReason: "",
    overtimeIn: "",
    overtimeOut: "",
    overtimeHours: "",
    photoOvertimeIn: "",
    photoOvertimeOut: "",
    range: "",
    notes: "",
    fileCIn: null,
    fileCOut: null,
    fileOIn: null,
    fileOOut: null,
    previewUrlCIn: "",
    previewUrlCOut: "",
    previewUrlOIn: "",
    previewUrlOOut: "",
  });

  const [editErrors, setEditErrors] = useState({
    attendanceId: false,
    nik: false,
    officeLocation: false,
    employeeName: false,
    company: false,
    attendanceDate: false,
    checkinTime: false,
    checkoutTime: false,
    photoCheckin: false,
    photoCheckout: false,
    workHours: false,
    attendanceStatus: false,
    leaveType: false,
    leaveReason: false,
    overtimeIn: false,
    overtimeOut: false,
    photoOvertimeIn: false,
    photoOvertimeOut: false,
    range: false,
    notes: false,
  });

  const fileInputRef = useRef<HTMLInputElement>(null);
  const addCInFileInputRef = useRef<HTMLInputElement>(null);
  const addCOutFileInputRef = useRef<HTMLInputElement>(null);
  const addOInFileInputRef = useRef<HTMLInputElement>(null);
  const addOOutFileInputRef = useRef<HTMLInputElement>(null);
  const editCInFileInputRef = useRef<HTMLInputElement>(null);
  const editCOutFileInputRef = useRef<HTMLInputElement>(null);
  const editOInFileInputRef = useRef<HTMLInputElement>(null);
  const editOOutFileInputRef = useRef<HTMLInputElement>(null);

  const handleFileUpload = (obj) => {
    const validTypes = ["image/png", "image/jpeg", "image/jpg"];
    const maxSize = 5 * 1024 * 1024; // 5MB

    const file = Object.values(obj)[0];

    if (!file) return;

    if (!validTypes.includes(file.type)) {
      Swal.fire({
        icon: "warning",
        title: "Format tidak didukung",
        text: "Hanya file .png, .jpg, dan .jpeg yang diperbolehkan",
      });
      return;
    }

    if (file.size > maxSize) {
      Swal.fire({
        icon: "warning",
        title: "Ukuran file terlalu besar",
        text: "Ukuran maksimum adalah 5MB",
      });
      return;
    }

    setAttendanceData({ ...attendanceData, ...obj });
  };

  const handleEditFileUpload = (obj) => {
    const validTypes = ["image/png", "image/jpeg", "image/jpg"];
    const maxSize = 5 * 1024 * 1024; // 5MB

    const file = Object.values(obj)[0];

    if (!file) return;

    if (!validTypes.includes(file.type)) {
      Swal.fire({
        icon: "warning",
        title: "Format tidak didukung",
        text: "Hanya file .png, .jpg, dan .jpeg yang diperbolehkan",
      });
      return;
    }

    if (file.size > maxSize) {
      Swal.fire({
        icon: "warning",
        title: "Ukuran file terlalu besar",
        text: "Ukuran maksimum adalah 5MB",
      });
      return;
    }

    setEditAttendanceData({ ...editAttendanceData, ...obj });
  };

  const [isLeave, setIsLeave] = useState(false);
  const [isLeaveEdit, setIsLeaveEdit] = useState(false);

  const handleInputChange = async (e) => {
    const { name, value } = e.target;
    let nama;
    if (name == 'attendanceStatus' && value == 'Leave') {
      setIsLeave(true);
    }
    if (name == 'attendanceStatus' && value != 'Leave') {
      setIsLeave(false);
    }
    await setAttendanceData({ ...attendanceData, [name]: value });
  };

  const handleEditInputChange = async (e) => {
    const { name, value } = e.target;
    let nama;
    if (name == 'attendanceStatus' && value == 'Leave') {
      setIsLeaveEdit(true);
    }
    if (name == 'attendanceStatus' && value != 'Leave') {
      setIsLeaveEdit(false);
    }

    await setEditAttendanceData({ ...editAttendanceData, [name]: value });
  };

  const validateForm = () => {
    let newErrors = {
      officeLocation: !attendanceData.officeLocation,
      attendanceStatus: !attendanceData.attendanceStatus,
      nik: !attendanceData.nik,
      employeeName: !attendanceData.employeeName,
    };

    setErrors(newErrors);
    return !Object.values(newErrors).includes(true);
  };

  const validateEditForm = () => {
    let newErrors = {
      officeLocation: !editAttendanceData.officeLocation,
      attendanceStatus: !editAttendanceData.attendanceStatus,
      attendanceId: !editAttendanceData.attendanceId,
      nik: !editAttendanceData.nik,
      employeeName: !editAttendanceData.employeeName,
    };

    setEditErrors(newErrors);
    return !Object.values(newErrors).includes(true);
  };

  const calculateWorkHours = (checkinTime: string, checkoutTime: string): string => {
    if (!checkinTime || !checkoutTime) return "";

    const checkin = dayjs(checkinTime, "HH:mm");
    const checkout = dayjs(checkoutTime, "HH:mm");

    if (!checkin.isValid() || !checkout.isValid()) {
      console.warn("Invalid time input:", checkinTime, checkoutTime);
      return "00:00:00";
    }

    const adjustedCheckout = checkout.isBefore(checkin) ? checkout.add(1, "day") : checkout;
    const durationInSeconds = adjustedCheckout.diff(checkin, "second");

    const hours = Math.floor(durationInSeconds / 3600);
    const minutes = Math.floor((durationInSeconds % 3600) / 60);
    const seconds = durationInSeconds % 60;

    const pad = (num: number) => String(num).padStart(2, '0');
    return `${pad(hours)}:${pad(minutes)}:${pad(seconds)}`;
  };


  const showPopupMandatoryError = () => {
    Swal.fire({
      icon: "error",
      title: "Data Belum Lengkap",
      text: "Lengkapi data yang wajib diisi.",
    });
  };

  const handleSubmitAddAttendance = async () => {
    if (validateForm()) {
      try {
        // Step 1: Create attendance
        // 🔢 Hitung workHours otomatis
        const calculatedWorkHours = await calculateWorkHours(attendanceData.checkinTime, attendanceData.checkoutTime);

        const newAttendance = await createAttendance({
          ...attendanceData,
          workHours: calculatedWorkHours,
        });

        // Step 2: Upload photo if available
        if (attendanceData.fileCIn) {
          await uploadAttendancePhoto(newAttendance.id, attendanceData.fileCIn, "photoCheckin");
        }
        if (attendanceData.fileCOut) {
          await uploadAttendancePhoto(newAttendance.id, attendanceData.fileCOut, "photoCheckout");
        }
        if (attendanceData.fileOIn) {
          await uploadAttendancePhoto(newAttendance.id, attendanceData.fileOIn, "photoOvertimeIn");
        }
        if (attendanceData.fileOOut) {
          await uploadAttendancePhoto(newAttendance.id, attendanceData.fileOOut, "photoOvertimeOut");
        }

        Swal.fire({
          icon: "success",
          title: "Attendance berhasil ditambahkan",
          confirmButtonColor: "#0F62FE",
        });
        await setOpenAddAttendanceDialog(false);
        await fetchAttendances();
        await setAttendanceData({
          nik: "",
          officeLocation: "",
          employeeName: "",
          company: "",
          employeeType: "",
          attendanceDate: dayjs().format("YYYY-MM-DD"),
          checkinTime: "",
          checkoutTime: "",
          photoCheckin: "",
          photoCheckout: "",
          workHours: "",
          attendanceStatus: "",
          leaveType: "",
          leaveReason: "",
          overtimeIn: "",
          overtimeOut: "",
          overtimeHours: "",
          photoOvertimeIn: "",
          photoOvertimeOut: "",
          range: "",
          notes: "",
          fileCIn: null,
          fileCOut: null,
          fileOIn: null,
          fileOOut: null,
        });

      } catch (error) {
        Swal.fire({
          icon: "error",
          title: "Gagal menambahkan attendance",
          text: error.response?.data?.message || "Terjadi kesalahan",
        });
      }

    } else {
      showPopupMandatoryError();
    }
  };

  const handleSubmitEditAttendance = async () => {
    if (validateEditForm()) {
      try {
        // 🔢 Hitung workHours otomatis
        const calculatedWorkHours = await calculateWorkHours(editAttendanceData.checkinTime, editAttendanceData.checkoutTime);

        const updatedAttendance = await editAttendance({
          ...editAttendanceData,
          workHours: calculatedWorkHours,
        });
        if (editAttendanceData.fileCIn && editAttendanceData.fileCIn.name !== originalEditAttendanceData.photoCheckin) {
          await uploadAttendancePhoto(editAttendanceData.id, editAttendanceData.fileCIn, "photoCheckin");
        }
        if (editAttendanceData.fileCOut && editAttendanceData.fileCOut.name !== originalEditAttendanceData.photoCheckout) {
          await uploadAttendancePhoto(editAttendanceData.id, editAttendanceData.fileCOut, "photoCheckout");
        }
        if (editAttendanceData.fileOIn && editAttendanceData.fileOIn.name !== originalEditAttendanceData.photoOvertimeIn) {
          await uploadAttendancePhoto(editAttendanceData.id, editAttendanceData.fileOIn, "photoOvertimeIn");
        }
        if (editAttendanceData.fileOOut && editAttendanceData.fileOOut.name !== originalEditAttendanceData.photoOvertimeOut) {
          await uploadAttendancePhoto(editAttendanceData.id, editAttendanceData.fileOOut, "photoOvertimeOut");
        }

        Swal.fire({
          icon: "success",
          title: "Attendance berhasil diperbarui",
          confirmButtonColor: "#0F62FE",
        });

        await setOpenEditAttendanceDialog(false);
        await setIsEditing(false);
        await fetchAttendances();

        // Optional: refresh item list
        await setCurrentPage(1); // agar fetch ulang
      } catch (error) {
        Swal.fire({
          icon: "error",
          title: "Gagal memperbarui item",
          text: error.response?.data?.message || "Terjadi kesalahan",
        });
      }

    }
  };

  const handleOpenEditAttendance = async (attendance) => {
    const photoCheckin = attendance.photoCheckin;
    const photoCheckout = attendance.photoCheckout;
    const photoOvertimeIn = attendance.photoOvertimeIn;
    const photoOvertimeOut = attendance.photoOvertimeOut;
    var status = attendance.attendanceStatus;
    if (attendance.attendanceStatus == "Valid" || attendance.attendanceStatus == "Not Valid") {
      status = "Presence";
    }
    let previewUrlCIn;
    if (photoCheckin && typeof photoCheckin === "string") {
      previewUrlCIn = await fetchAttendancePhotoBlob(photoCheckin);
    }
    let previewUrlCOut;
    if (photoCheckout && typeof photoCheckout === "string") {
      previewUrlCOut = await fetchAttendancePhotoBlob(photoCheckout);
    }
    let previewUrlOIn;
    if (photoOvertimeIn && typeof photoOvertimeIn === "string") {
      previewUrlOIn = await fetchAttendancePhotoBlob(photoOvertimeIn);
    }
    let previewUrlOOut;
    if (photoOvertimeOut && typeof photoOvertimeOut === "string") {
      previewUrlOOut = await fetchAttendancePhotoBlob(photoOvertimeOut);
    }

    await setEditAttendanceData({
      ...attendance,
      fileCIn: null,
      fileCOut: null,
      fileOIn: null,
      fileOOut: null,
      photoCheckin: attendance.photoCheckin,
      previewUrlCIn, // ← simpan di state
      photoCheckout: attendance.photoCheckout,
      previewUrlCOut, // ← simpan di state
      photoOvertimeIn: attendance.photoOvertimeIn,
      previewUrlOIn, // ← simpan di state
      photoOvertimeOut: attendance.photoOvertimeOut,
      previewUrlOOut, // ← simpan di state
      attendanceStatus: status,
    });
    setOriginalEditAttendanceData(attendance); // Simpan nilai asli untuk tombol cancel
    setIsEditing(false); // Kunci form sampai tombol edit diklik
    setOpenEditAttendanceDialog(true);
  };

  const handleSelectRow = (id: number) => {
    setSelectedRows((prev) =>
      prev.includes(id) ? prev.filter((rowId) => rowId !== id) : [...prev, id]
    );
  };

  const handleDeleteRows = async () => {
    try {
      await Promise.all(selectedRows.map(async (id) => await deleteAttendance(id)));

      Swal.fire({
        icon: "success",
        title: "Attendance berhasil dihapus",
        confirmButtonColor: "#0F62FE",
      });

      setSelectedRows([]);
      fetchAttendances(); // refresh data
      setOpenDeleteDialog(false);
    } catch (error) {
      Swal.fire({
        icon: "error",
        title: "Gagal menghapus item",
        text: error.response?.data?.message || "Terjadi kesalahan",
      });
    }
  };

  const handleCancelEditAttendance = () => {
    setEditAttendanceData(originalEditAttendanceData); // Kembalikan nilai asli
    setIsEditing(false); // Kunci kembali form
    setOpenEditAttendanceDialog(false);
  };

  // FILTER

  const handleFilterChange = (index: number, key: string, value: string) => {
    const newFilters = [...filters];
    newFilters[index][key] = value;
    setFilters(newFilters);
  };

  const handleAddFilter = () => {
    setFilters([...filters, { field: "id", value: "" }]);
  };

  const handleRemoveFilter = (index: number) => {
    setFilters(filters.filter((_, i) => i !== index));
  };

  const handleApplyFilters = async () => {
    setIsLoading(true);
    try {
      const searchParams: AttendanceSearchParams = {};

      if (startDate && endDate) {
        if (startDate === endDate) {
          searchParams.attendanceDate = await startDate;
        } else {
          searchParams.startDate = await startDate;
          searchParams.endDate = await endDate;
        }
      }

      if (startDate && !endDate) {
        searchParams.attendanceDate = await startDate;
      }

      await filters.forEach((filter) => {
        if (filter.value.trim() !== "") {
          searchParams[filter.field] = filter.value;
        }
      });

      await setFilterParams(searchParams);
      await setOpenFilterDialog(false);
    } catch (error) {
      console.error("Error fetching data:", error);
      Swal.fire({
        icon: "error",
        title: "Gagal mengambil data",
        text: error.response?.data?.message || "Terjadi kesalahan",
      });
      handleCloseFilter();
    } finally {
      setIsLoading(false);
    }
  };


  // ✅ Tambahkan fungsi ini
  const handleSearchResults = (results) => {
    setRows(results); // Update rows agar sesuai dengan format tabel
    setOpenFilterDialog(false); // Tutup dialog setelah apply filter
  };

  const handleCloseFilter = () => {
    setOpenFilterDialog(false);
  };

  const handleResetFilters = () => {
    setFilters([{ field: "", value: "" }]);
    setStartDate(null);
    setEndDate(null);
  };



  //======================= Search ===================================
  const handleSearch = async () => {
    // if (searchQuery.trim() === "") return; // Hindari pencarian kosong
    setIsLoading(true);
    setError("");

    try {
      // const results = await getAttendances({
      //   keyword: searchQuery,
      //   limit: rowsPerPage,
      //   offset,
      // });
      setFilterParams(
        {
          keyword: searchQuery
        }
      );
    } catch (err) {
      setError(err);
    } finally {
      setIsLoading(false);
    }
  };

  const handleExport = async () => {
    try {
      // Tampilkan loading
      Swal.fire({
        title: 'Preparing Export...',
        allowOutsideClick: false,
        didOpen: () => {
          Swal.showLoading();
        }
      });

      // Opsi 1: Export semua data (dengan filter yang sama seperti tabel)
      const exportData = await getExportData();

      // Opsi 2: Export hanya data yang terlihat di tabel saat ini
      // const exportData = rows.map(formatEmployeeForExport);

      // Opsi 3: Export hanya data yang dipilih
      // if (selectedRows.length === 0) {
      //   Swal.fire({
      //     icon: 'warning',
      //     title: 'No Selection',
      //     text: 'Please select at least one employee to export',
      //   });
      //   return;
      // }
      // const exportData = rows
      //   .filter(row => selectedRows.includes(row.id))
      //   .map(formatEmployeeForExport);

      // Buat worksheet
      const ws = XLSX.utils.json_to_sheet(exportData);

      // Buat workbook
      const wb = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(wb, ws, "Attendance");

      // Generate file Excel
      const date = new Date().toISOString().slice(0, 10);
      XLSX.writeFile(wb, `Attendances_${date}.xlsx`);

      // Tutup loading
      Swal.close();

    } catch (error) {
      console.error('Export failed:', error);
      Swal.fire({
        icon: 'error',
        title: 'Export Failed',
        text: error.message || 'Failed to export attendance data',
      });
    }
  };

  // Fungsi untuk mengambil data yang akan diexport
  const getExportData = async () => {
    const allAttendances = await getAttendances({
      ...filterParams,
      limit: 10000, // Ambil semua data
      offset: 0,
      orderBy: sortConfig.orderBy,
      order: sortConfig.order,
    });

    return allAttendances.data.map(attendance => ({
      'Date': attendance.attendanceDate,
      'Employee Name': attendance.employeeName,
      'NIK': attendance.nik,
      'Office Location': attendance.officeLocation,
      'Vendor': employees[attendance.nik]?.company || "-",
      'Attendance Status': attendance.attendanceStatus,
      'Check In': attendance.checkinTime,
      'Check Out': attendance.checkoutTime,
      'Total Work Hours': attendance.workHours,
      'Overtime In': attendance.overtimeIn,
      'Overtime Out': attendance.overtimeOut,
      'Total Overtime Hours': calculateWorkHours(attendance.overtimeIn, attendance.overtimeOut),
    }));
  };

  return (
    <Box sx={{ padding: 3 }}>
      {/* Header & Tabs */}
      <Box sx={{ display: "flex", alignItems: "center", gap: 2, marginBottom: 2 }}>
        <Typography variant="h6" fontWeight="bold">
          Attendance List
        </Typography>
      </Box>

      {/* Toolbar */}
      <Box className="toolbar">
        {/* Left Controls */}
        <Box className="leftControls">
          <Typography>Show</Typography>
          <Select value={rowsPerPage} onChange={(e) => {
            setRowsPerPage(Number(e.target.value));
            setCurrentPage(1); // reset ke halaman 1 saat ganti limit
          }} size="small">
            <MenuItem value={5}>5</MenuItem>
            <MenuItem value={10}>10</MenuItem>
            <MenuItem value={25}>25</MenuItem>
            <MenuItem value={50}>50</MenuItem>
          </Select>

          {/* Search Button & Input */}
          <Button
            variant="contained"
            startIcon={<Search />}
            onClick={() => setShowSearch((prev) => !prev)}
            className="searchButton"
          >
            Search
          </Button>
          {showSearch && (
            <TextField
              variant="outlined"
              size="small"
              placeholder="Search"
              value={searchQuery}
              onChange={async (e) => {
                await setSearchQuery(e.target.value);
              }}
              onKeyPress={(e) => e.key === "Enter" && handleSearch()} // Pencarian dengan Enter
              autoFocus
              className="searchInput"
            />
          )}

          {/* Menampilkan Error */}
          {error && <p style={{ color: "red" }}>{error}</p>}
        </Box>

        {/* Right Controls */}
        <Box className="rightControls">
          <Button
            startIcon={<Delete />}
            variant="text"
            onClick={() => {
              const selectedData = rows.filter((row) => selectedRows.includes(row.id));
              setItemsToDelete(selectedData);
              setOpenDeleteDialog(true);
            }}
            disabled={selectedRows.length === 0}
          >
            Delete
          </Button>
          {/* Filter Button */}
          <Button
            startIcon={<FilterList />}
            variant="text"
            onClick={() => setOpenFilterDialog(true)}
          >
            Filters
          </Button>
          <Button startIcon={<Download />} variant="contained" className="exportButton" onClick={() => handleExport()}>
            Export
          </Button>
          <Button startIcon={<Add />} variant="contained" className="addItemDetailsButton" onClick={() => setOpenAddAttendanceDialog(true)}>
            Add New Attendance
          </Button>
        </Box>
      </Box>


      {/* Delete Button & Subtitle */}

      <Box className="deleteContainer">
        <Typography variant="body2" className="detailsSubtitle">
          Details List Of All Attendances
        </Typography>
      </Box>


      {/* Table */}
      <TableContainer component={Paper} className="tableContainer">
        <Table className="table">
          <TableHead className="tableHead">
            <TableRow>
              {/* Checkbox header */}
              <TableCell padding="checkbox" className="tableCell">
                <Checkbox
                  indeterminate={selectedRows.length > 0 && selectedRows.length < rows.length}
                  checked={selectedRows.length === rows.length}
                  onChange={() =>
                    setSelectedRows(selectedRows.length === rows.length ? [] : rows.map((row) => row.id))
                  }
                />
              </TableCell>
              <TableCell>No</TableCell>
              {/* Header dengan sorting */}
              <TableCell className="tableCell" onClick={() => handleSort("attendanceDate")} style={{ cursor: "pointer" }}>
                <strong>Attendance Date</strong>
                {sortConfig.orderBy === "attendanceDate" && (sortConfig.order === "asc" ? " ▲" : " ▼")}
              </TableCell>
              <TableCell className="tableCell" onClick={() => handleSort("employeeName")} style={{ cursor: "pointer" }}>
                <strong>Employee Name</strong>
                {sortConfig.orderBy === "employeeName" && (sortConfig.order === "asc" ? " ▲" : " ▼")}
              </TableCell>
              <TableCell className="tableCell" onClick={() => handleSort("attendanceId")} style={{ cursor: "pointer" }}>
                <strong>NIK</strong>
                {sortConfig.orderBy === "attendanceId" && (sortConfig.order === "asc" ? " ▲" : " ▼")}
              </TableCell>
              <TableCell className="tableCell" onClick={() => handleSort("attendanceStatus")} style={{ cursor: "pointer" }}>
                <strong>Attendance Status</strong>
                {sortConfig.orderBy === "attendanceStatus" && (sortConfig.order === "asc" ? " ▲" : " ▼")}
              </TableCell>
              <TableCell className="tableCell" onClick={() => handleSort("checkinTime")} style={{ cursor: "pointer" }}>
                <strong>Check In</strong>
                {sortConfig.orderBy === "checkinTime" && (sortConfig.order === "asc" ? " ▲" : " ▼")}
              </TableCell>
              <TableCell className="tableCell" onClick={() => handleSort("checkoutTime")} style={{ cursor: "pointer" }}>
                <strong>Check Out</strong>
                {sortConfig.orderBy === "checkoutTime" && (sortConfig.order === "asc" ? " ▲" : " ▼")}
              </TableCell>
              <TableCell className="tableCell" onClick={() => handleSort("officeLocation")} style={{ cursor: "pointer" }}>
                <strong>Office Location</strong>
                {sortConfig.orderBy === "officeLocation" && (sortConfig.order === "asc" ? " ▲" : " ▼")}
              </TableCell>
              <TableCell className="tableCell" onClick={() => handleSort("workHours")} style={{ cursor: "pointer" }}>
                <strong>Total Work Hours</strong>
                {sortConfig.orderBy === "workHours" && (sortConfig.order === "asc" ? " ▲" : " ▼")}
              </TableCell><TableCell className="tableCell" onClick={() => handleSort("overtimeIn")} style={{ cursor: "pointer" }}>
                <strong>Overtime In</strong>
                {sortConfig.orderBy === "overtimeIn" && (sortConfig.order === "asc" ? " ▲" : " ▼")}
              </TableCell>
              <TableCell className="tableCell" onClick={() => handleSort("overtimeOut")} style={{ cursor: "pointer" }}>
                <strong>Overtime Out</strong>
                {sortConfig.orderBy === "overtimeOut" && (sortConfig.order === "asc" ? " ▲" : " ▼")}
              </TableCell>
              <TableCell className="tableCell" onClick={() => handleSort("overtimeHours")} style={{ cursor: "pointer" }}>
                <strong>Overtime Hours</strong>
                {sortConfig.orderBy === "overtimeHours" && (sortConfig.order === "asc" ? " ▲" : " ▼")}
              </TableCell>
              <TableCell className="tableCell">
              </TableCell> {/* Kolom untuk aksi */}
            </TableRow>
          </TableHead>
          <TableBody>
            {rows.map((row, index) => (
              <TableRow key={row.id} selected={selectedRows.includes(row.id)}>
                {/* Checkbox */}
                <TableCell padding="checkbox" className="tableCell">
                  <Checkbox
                    checked={selectedRows.includes(row.id)}
                    onChange={() => handleSelectRow(row.id)}
                  />
                </TableCell>
                <TableCell>
                  {/* Nomor urut disesuaikan dengan pagination */}
                  {offset + index + 1}
                </TableCell>
                {/* Data */}
                <TableCell className="tableCell" title={row.attendanceDate}><strong>{row.attendanceDate}</strong></TableCell>
                <TableCell className="tableCell" title={row.employeeName}><strong>{row.employeeName}</strong></TableCell>
                <TableCell className="tableCell" title={row.nik}>{row.nik}</TableCell>
                {/* Status Badge */}
                <TableCell className="tableCell" title={row.attendanceStatus}>
                  <Box className="statusBadge" style={{ backgroundColor: statusColors[row.attendanceStatus] || "grey" }}>
                    {row.attendanceStatus}
                  </Box>
                </TableCell>
                <TableCell className="tableCell" title={row.checkinTime}>{row.checkinTime}</TableCell>
                <TableCell className="tableCell" title={row.checkoutTime}>{row.checkoutTime}</TableCell>
                <TableCell className="tableCell" title={row.officeLocation}>{row.officeLocation}</TableCell>
                <TableCell className="tableCell" title={row.workHours}>{row.workHours}</TableCell>
                <TableCell className="tableCell" title={row.overtimeIn}>{row.overtimeIn}</TableCell>
                <TableCell className="tableCell" title={row.overtimeOut}>{row.overtimeOut}</TableCell>
                <TableCell className="tableCell" title={row.overtimeHours}>{row.overtimeHours}</TableCell>

                {/* Ikon More Options */}
                {/* Ikon More Options */}
                <TableCell className="tableCell">
                  <IconButton onClick={() => handleOpenEditAttendance(row)}>
                    <MoreVert />
                  </IconButton>
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>


      {/* Pagination */}
      <Box
        className="paginationContainer"
        sx={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          width: "100%",
          padding: "16px 0",
        }}
      >
        {/* Info jumlah data */}
        <Typography variant="body2" sx={{ color: "text.secondary" }}>
          {`Showing ${offset + 1} to ${Math.min(
            offset + rowsPerPage,
            totalItems
          )} of ${totalItems} entries`}
        </Typography>

        {/* Komponen Pagination */}
        <Pagination
          count={totalPages}
          page={currentPage}
          onChange={(e, page) => setCurrentPage(page)}
          className="pagination"
          showFirstButton
          showLastButton
          renderItem={(item) => (
            <PaginationItem
              {...item}
              components={{ first: FirstPage, last: LastPage }}
            />
          )}
        />
      </Box>

      {/* Delete Confirmation Dialog */}
      <Dialog open={openDeleteDialog} onClose={() => setOpenDeleteDialog(false)}>
        <DialogTitle>Delete Rows?</DialogTitle>
        <DialogContent>
          <DialogContentText>Are you sure you want to delete the selected rows?</DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setOpenDeleteDialog(false)}>Cancel</Button>
          <Button onClick={handleDeleteRows} color="error">Delete</Button>
        </DialogActions>
      </Dialog>

      {/* POPUP Add New Attendance */}
      <Dialog open={openAddAttendanceDialog} onClose={() => setOpenAddAttendanceDialog(false)} fullWidth maxWidth="lg"
        sx={{ backdropFilter: "blur(5px)", borderRadius: "10px" }}>
        <DialogTitle>
          <Box sx={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
            <Typography variant="h6" fontWeight="bold">Add New Attendance</Typography>
            <IconButton onClick={() => setOpenAddAttendanceDialog(false)} color="error"><Close /></IconButton>
          </Box>
        </DialogTitle>

        <DialogContent>
          <Box sx={{ display: "flex", gap: 2 }}>
            {/* Grid Layout */}
            <Grid container spacing={3}>
              {/* File Upload Section */}
              {/* <Grid item xs={12} md={4}>
                <Typography variant="subtitle2" sx={{ mt: 1 }}>Choose Photo Type</Typography>
                <Typography variant="caption" sx={{ color: "#666" }}>Checkin / Check Out / Overtime In / Overtime Out</Typography>
                <FormControl fullWidth margin="dense">
                  <Select
                    name="choosenField"
                    value={choosenField}
                    onChange={(e) => setChoosenField(e.target.value)}
                    displayEmpty
                  >
                    <MenuItem value="">Select item</MenuItem>
                    {fields.map((field) => (
                      <MenuItem key={field.id} value={field.id}>
                        {field.shown}
                      </MenuItem>
                    ))}
                  </Select>

                </FormControl>
                <Box
                  sx={{
                    flex: 1,
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "center",
                    justifyContent: "center",
                    border: "2px dashed #aaa",
                    padding: 4,
                    borderRadius: "12px",
                    backgroundColor: "#fafafa",
                    textAlign: "center",
                    cursor: "pointer",
                    position: "relative",
                    height: "300px",
                  }}
                  onDragOver={(e) => e.preventDefault()}
                  onDrop={(e) => {
                    e.preventDefault();
                    const file = e.dataTransfer.files[0];
                    handleFileUpload(file);
                  }}
                  onClick={() => fileInputRef.current?.click()}
                >
                  {attendanceData.file ? (
                    <img
                      src={URL.createObjectURL(attendanceData.file)}
                      alt="Preview"
                      style={{ width: "100%", height: "auto", borderRadius: "8px", objectFit: "contain", maxHeight: 180 }}
                    />
                  ) : (
                    <>
                      <PhotoCamera fontSize="large" />
                      <Typography variant="body2" color="textSecondary" mt={1}>
                        Drag & drop or click to upload image
                      </Typography>
                    </>
                  )}
                  <input
                    hidden
                    accept="image/png, image/jpeg, image/jpg"
                    type="file"
                    ref={fileInputRef}
                    onChange={(e) => handleFileUpload(e.target.files[0])}
                  />
                  <Typography variant="caption" mt={1}>
                    Max size: 5MB (.png, .jpg, .jpeg)
                  </Typography>
                </Box>
              </Grid> */}

              {/* Left Section */}
              <Grid item xs={12} md={4}>
                <Typography variant="subtitle2" sx={{ mt: 1 }}>Office Location</Typography>
                <Typography variant="caption" sx={{ color: "#666" }}>Choose One</Typography>
                <FormControl fullWidth margin="dense">
                  <Autocomplete
                    options={officeOptions}
                    getOptionLabel={(option) => option.officeName || ""}
                    value={officeOptions.find(opt => opt.officeName === attendanceData.officeLocation) || null}
                    onChange={(event, newValue) => {
                      handleInputChange({
                        target: {
                          name: "officeLocation",
                          value: newValue ? newValue.officeName : ""
                        }
                      });
                    }}
                    renderInput={(params) => (
                      <TextField
                        {...params}
                        label="Office Location"
                        placeholder="Select Office"
                        margin="dense"
                        fullWidth
                      />
                    )}
                  />


                </FormControl>

                <Typography variant="subtitle2" sx={{ mt: 1 }}>Attendance Status</Typography>
                <Typography variant="caption" sx={{ color: "#666" }}>Choose One</Typography>
                <FormControl fullWidth margin="dense">
                  <TextField
                    select
                    name="attendanceStatus"
                    // value={attendanceData.attendanceStatus}
                    onChange={handleInputChange}
                    error={!attendanceData.attendanceStatus || errors.attendanceStatus}
                    helperText={!attendanceData.attendanceStatus || errors.attendanceStatus ? "Mandatory Field" : ""}
                  >
                    <MenuItem aria-placeholder="Select Status" value="">Select Status</MenuItem>

                    <MenuItem key="Presence" value="Presence">
                      Presence
                    </MenuItem>
                    <MenuItem key="Leave" value="Leave">
                      Leave
                    </MenuItem>
                  </TextField>

                </FormControl>

                <Typography variant="subtitle2" sx={{ mt: 1 }}>Leave Type</Typography>
                <Typography variant="caption" sx={{ color: "#666" }}>Choose One</Typography>
                <FormControl fullWidth margin="dense">
                  <Select
                    name="leaveType"
                    // value={officeOptions.officeName}
                    onChange={handleInputChange}
                    disabled={!isLeave}
                  >
                    <MenuItem value="">Select Leave Type</MenuItem>

                    <MenuItem key="Sick Leave" value="Sick Leave">
                      Sick Leave
                    </MenuItem>
                    <MenuItem key="Annual Leave" value="Annual Leave">
                      Annual Leave
                    </MenuItem>
                  </Select>

                </FormControl>

                <TextField
                  label="Range"
                  name="range"
                  value={attendanceData.range}
                  onChange={handleInputChange}
                  fullWidth
                  margin="normal"
                />


              </Grid>

              {/* Right Section */}
              <Grid item xs={12} md={4}>

                <TextField
                  label="Nomor Induk Karyawan"
                  name="nik"
                  value={attendanceData.nik}
                  onChange={async (e) => {
                    const nik = e.target.value;
                    const employeeName = employees[nik]?.name || "";
                    const company = employees[nik]?.company || "";
                    const employeeType = employees[nik]?.employeeType || "";
                    setAttendanceData({ ...attendanceData, nik, employeeName, company, employeeType });
                  }}
                  fullWidth
                  margin="dense"
                  error={!attendanceData.nik}
                  helperText={!attendanceData.nik ? "Mandatory Field" : ""}
                />
                {attendanceData.nik && !employees[attendanceData.nik] && (
                  <Typography variant="caption" color="error">
                    NIK tidak ditemukan
                  </Typography>
                )}

                <TextField
                  label="Nama Karyawan"
                  name="employeeName"
                  value={attendanceData.employeeName}
                  fullWidth
                  disabled
                  margin="dense"
                  error={!attendanceData.employeeName}
                  helperText={!attendanceData.employeeName ? "Mandatory Field" : ""}
                />

                <TextField
                  label="Status Karyawan"
                  name="employeeType"
                  value={attendanceData.employeeType}
                  fullWidth
                  disabled
                  margin="dense"
                />

                <TextField
                  label="Vendor"
                  name="company"
                  value={attendanceData.company}
                  fullWidth
                  disabled
                  margin="dense"
                />

                <LocalizationProvider dateAdapter={AdapterDayjs}>
                  <DesktopDatePicker
                    label="Select Date"
                    format="YYYY-MM-DD"
                    value={
                      attendanceData.attendanceDate
                        ? dayjs(attendanceData.attendanceDate)
                        : null
                    }
                    onChange={(newValue) =>
                      handleInputChange({
                        target: {
                          name: "attendanceDate",
                          value: newValue
                            ? dayjs(newValue).format("YYYY-MM-DD")
                            : "",
                        },
                      })
                    }
                    slotProps={{
                      textField: {
                        margin: "normal",
                        fullWidth: true,
                        sx: { mb: 1 },
                        name: "attendanceDate",
                        error: !attendanceData.attendanceDate,
                        helperText: !attendanceData.attendanceDate
                          ? "Mandatory Field"
                          : "",
                      },
                    }}
                  />
                </LocalizationProvider>

                {/* <Grid container spacing={1} alignItems="center" sx={{ mb: 1 }}>
                  <Grid item xs={6}>
                    <LocalizationProvider dateAdapter={AdapterDayjs}>
                      <TimePicker
                        label="Checkin Time"
                        ampm={false}
                        value={attendanceData.checkinTime ? dayjs(attendanceData.checkinTime, 'HH:mm') : null}
                        onChange={(newValue) =>
                          setAttendanceData({ ...attendanceData, checkinTime: newValue?.format('HH:mm:ss') || '' })
                        }
                        name="checkinTime"
                        className="timePicker"
                        slotProps={{ textField: { fullWidth: true, margin: 'dense' } }}
                      />
                    </LocalizationProvider>
                  </Grid>
                  <Grid item xs={6}>
                    <LocalizationProvider dateAdapter={AdapterDayjs}>
                      <TimePicker
                        label="Checkout Time"
                        ampm={false}
                        value={attendanceData.checkoutTime ? dayjs(attendanceData.checkoutTime, 'HH:mm') : null}
                        onChange={(newValue) =>
                          setAttendanceData({ ...attendanceData, checkoutTime: newValue?.format('HH:mm:ss') || '' })
                        }
                        name="checkoutTime"
                        className="timePicker"
                        slotProps={{ textField: { fullWidth: true, margin: 'dense' } }}
                      />
                    </LocalizationProvider>
                  </Grid>
                </Grid>
                <Grid container spacing={1} alignItems="center" sx={{ mb: 1 }}>
                  <Grid item xs={6}>
                    <LocalizationProvider dateAdapter={AdapterDayjs}>
                      <TimePicker
                        label="Overtime In"
                        ampm={false}
                        value={attendanceData.overtimeIn ? dayjs(attendanceData.overtimeIn, 'HH:mm') : null}
                        onChange={(newValue) =>
                          setAttendanceData({ ...attendanceData, overtimeIn: newValue?.format('HH:mm:ss') || '' })
                        }
                        name="overtimeIn"
                        className="timePicker"
                        slotProps={{ textField: { fullWidth: true, margin: 'dense' } }}
                      />
                    </LocalizationProvider>
                  </Grid>
                  <Grid item xs={6}>
                    <LocalizationProvider dateAdapter={AdapterDayjs}>
                      <TimePicker
                        label="Overtime Out"
                        ampm={false}
                        value={attendanceData.overtimeOut ? dayjs(attendanceData.overtimeOut, 'HH:mm') : null}
                        onChange={(newValue) =>
                          setAttendanceData({ ...attendanceData, overtimeOut: newValue?.format('HH:mm:ss') || '' })
                        }
                        name="overtimeOut"
                        className="timePicker"
                        slotProps={{ textField: { fullWidth: true, margin: 'dense' } }}
                      />
                    </LocalizationProvider>
                  </Grid>
                </Grid> */}


                {/* Remarks Section */}
                <Typography variant="subtitle2" sx={{ mt: 3 }}>Add Notes</Typography>
                <Typography variant="caption" sx={{ color: "#666" }}>Sample Description</Typography>
                <TextField
                  name="notes"
                  value={attendanceData.notes}
                  onChange={handleInputChange}
                  fullWidth
                  multiline
                  rows={3}
                  margin="dense"
                  placeholder="Placeholder text"
                />
                <Typography variant="caption" sx={{ textAlign: "right", display: "block", color: "#666" }}>
                  {attendanceData.notes.length}/160 Characters
                </Typography>
              </Grid>

              {/* File Upload Section */}
              <Grid item xs={12} md={4}>

                <Grid container spacing={1} alignItems="center" sx={{ mb: 1 }}>
                  <Grid item xs={6}>
                    <Box
                      sx={{
                        flex: 1,
                        display: "flex",
                        flexDirection: "column",
                        alignItems: "center",
                        justifyContent: "center",
                        border: "2px dashed #aaa",
                        padding: 4,
                        borderRadius: "12px",
                        backgroundColor: "#fafafa",
                        textAlign: "center",
                        cursor: "pointer",
                        position: "relative",
                        height: "100px",
                      }}
                      onDragOver={(e) => e.preventDefault()}
                      onDrop={(e) => {
                        e.preventDefault();
                        const file = e.dataTransfer.files[0];
                        handleFileUpload({ fileCIn: file });
                      }}
                      onClick={() => addCInFileInputRef.current?.click()}
                    >
                      {attendanceData.fileCIn ? (
                        <img
                          src={URL.createObjectURL(attendanceData.fileCIn)}
                          alt="Preview"
                          style={{ width: "100%", height: "auto", borderRadius: "8px", objectFit: "contain", maxHeight: 180 }}
                        />
                      ) : (
                        <>
                          <PhotoCamera fontSize="large" />
                          <Typography variant="body2" color="textSecondary" mt={1}>
                            Drag & drop or click to upload image
                          </Typography>
                        </>
                      )}
                      <input
                        hidden
                        accept="image/png, image/jpeg, image/jpg"
                        type="file"
                        ref={addCInFileInputRef}
                        onChange={(e) => handleFileUpload({ fileCIn: e.target.files[0] })}
                      />
                      <Typography variant="caption" mt={1}>
                        Max size: 5MB (.png, .jpg, .jpeg)
                      </Typography>
                    </Box>
                    <LocalizationProvider dateAdapter={AdapterDayjs}>
                      <TimePicker
                        label="Checkin Time"
                        ampm={false}
                        value={attendanceData.checkinTime ? dayjs(attendanceData.checkinTime, 'HH:mm') : null}
                        onChange={(newValue) =>
                          setAttendanceData({ ...attendanceData, checkinTime: newValue?.format('HH:mm:ss') || '' })
                        }
                        name="checkinTime"
                        className="timePicker"
                        minutesStep={1}
                        slotProps={{ textField: { fullWidth: true, margin: 'normal' } }}
                      />
                    </LocalizationProvider>
                  </Grid>
                  <Grid item xs={6}>
                    <Box
                      sx={{
                        flex: 1,
                        display: "flex",
                        flexDirection: "column",
                        alignItems: "center",
                        justifyContent: "center",
                        border: "2px dashed #aaa",
                        padding: 4,
                        borderRadius: "12px",
                        backgroundColor: "#fafafa",
                        textAlign: "center",
                        cursor: "pointer",
                        position: "relative",
                        height: "100px",
                      }}
                      onDragOver={(e) => e.preventDefault()}
                      onDrop={(e) => {
                        e.preventDefault();
                        const file = e.dataTransfer.files[0];
                        handleFileUpload({ fileCOut: file });
                      }}
                      onClick={() => addCOutFileInputRef.current?.click()}
                    >
                      {attendanceData.fileCOut ? (
                        <img
                          src={URL.createObjectURL(attendanceData.fileCOut)}
                          alt="Preview"
                          style={{ width: "100%", height: "auto", borderRadius: "8px", objectFit: "contain", maxHeight: 180 }}
                        />
                      ) : (
                        <>
                          <PhotoCamera fontSize="large" />
                          <Typography variant="body2" color="textSecondary" mt={1}>
                            Drag & drop or click to upload image
                          </Typography>
                        </>
                      )}
                      <input
                        hidden
                        accept="image/png, image/jpeg, image/jpg"
                        type="file"
                        ref={addCOutFileInputRef}
                        onChange={(e) => handleFileUpload({ fileCOut: e.target.files[0] })}
                      />
                      <Typography variant="caption" mt={1}>
                        Max size: 5MB (.png, .jpg, .jpeg)
                      </Typography>
                    </Box>
                    <LocalizationProvider dateAdapter={AdapterDayjs}>
                      <TimePicker
                        label="Checkout Time"
                        ampm={false}
                        value={attendanceData.checkoutTime ? dayjs(attendanceData.checkoutTime, 'HH:mm') : null}
                        onChange={(newValue) =>
                          setAttendanceData({ ...attendanceData, checkoutTime: newValue?.format('HH:mm:ss') || '' })
                        }
                        name="checkoutTime"
                        className="timePicker"
                        minutesStep={1}
                        slotProps={{ textField: { fullWidth: true, margin: 'normal' } }}
                      />
                    </LocalizationProvider>
                  </Grid>
                  <Grid item xs={6}>

                    <Box
                      sx={{
                        flex: 1,
                        display: "flex",
                        flexDirection: "column",
                        alignItems: "center",
                        justifyContent: "center",
                        border: "2px dashed #aaa",
                        padding: 4,
                        borderRadius: "12px",
                        backgroundColor: "#fafafa",
                        textAlign: "center",
                        cursor: "pointer",
                        position: "relative",
                        height: "100px",
                      }}
                      onDragOver={(e) => e.preventDefault()}
                      onDrop={(e) => {
                        e.preventDefault();
                        const file = e.dataTransfer.files[0];
                        handleFileUpload({ fileOIn: file });
                      }}
                      onClick={() => addOInFileInputRef.current?.click()}
                    >
                      {attendanceData.fileOIn ? (
                        <img
                          src={URL.createObjectURL(attendanceData.fileOIn)}
                          alt="Preview"
                          style={{ width: "100%", height: "auto", borderRadius: "8px", objectFit: "contain", maxHeight: 180 }}
                        />
                      ) : (
                        <>
                          <PhotoCamera fontSize="large" />
                          <Typography variant="body2" color="textSecondary" mt={1}>
                            Drag & drop or click to upload image
                          </Typography>
                        </>
                      )}
                      <input
                        hidden
                        accept="image/png, image/jpeg, image/jpg"
                        type="file"
                        ref={addOInFileInputRef}
                        onChange={(e) => handleFileUpload({ fileOIn: e.target.files[0] })}
                      />
                      <Typography variant="caption" mt={1}>
                        Max size: 5MB (.png, .jpg, .jpeg)
                      </Typography>
                    </Box>
                    <LocalizationProvider dateAdapter={AdapterDayjs}>
                      <TimePicker
                        label="Overtime In"
                        ampm={false}
                        value={attendanceData.overtimeIn ? dayjs(attendanceData.overtimeIn, 'HH:mm') : null}
                        onChange={(newValue) =>
                          setAttendanceData({ ...attendanceData, overtimeIn: newValue?.format('HH:mm:ss') || '' })
                        }
                        name="overtimeIn"
                        className="timePicker"
                        minutesStep={1}
                        slotProps={{ textField: { fullWidth: true, margin: 'normal' } }}
                      />
                    </LocalizationProvider>
                  </Grid>
                  <Grid item xs={6}>

                    <Box
                      sx={{
                        flex: 1,
                        display: "flex",
                        flexDirection: "column",
                        alignItems: "center",
                        justifyContent: "center",
                        border: "2px dashed #aaa",
                        padding: 4,
                        borderRadius: "12px",
                        backgroundColor: "#fafafa",
                        textAlign: "center",
                        cursor: "pointer",
                        position: "relative",
                        height: "100px",
                      }}
                      onDragOver={(e) => e.preventDefault()}
                      onDrop={(e) => {
                        e.preventDefault();
                        const file = e.dataTransfer.files[0];
                        handleFileUpload({ fileOOut: file });
                      }}
                      onClick={() => addOOutFileInputRef.current?.click()}
                    >
                      {attendanceData.fileOOut ? (
                        <img
                          src={URL.createObjectURL(attendanceData.fileOOut)}
                          alt="Preview"
                          style={{ width: "100%", height: "auto", borderRadius: "8px", objectFit: "contain", maxHeight: 180 }}
                        />
                      ) : (
                        <>
                          <PhotoCamera fontSize="large" />
                          <Typography variant="body2" color="textSecondary" mt={1}>
                            Drag & drop or click to upload image
                          </Typography>
                        </>
                      )}
                      <input
                        hidden
                        accept="image/png, image/jpeg, image/jpg"
                        type="file"
                        ref={addOOutFileInputRef}
                        onChange={(e) => handleFileUpload({ fileOOut: e.target.files[0] })}
                      />
                      <Typography variant="caption" mt={1}>
                        Max size: 5MB (.png, .jpg, .jpeg)
                      </Typography>
                    </Box>
                    <LocalizationProvider dateAdapter={AdapterDayjs}>
                      <TimePicker
                        label="Overtime Out"
                        ampm={false}
                        value={attendanceData.overtimeOut ? dayjs(attendanceData.overtimeOut, 'HH:mm') : null}
                        onChange={(newValue) =>
                          setAttendanceData({ ...attendanceData, overtimeOut: newValue?.format('HH:mm:ss') || '' })
                        }
                        name="overtimeOut"
                        className="timePicker"
                        minutesStep={1}
                        slotProps={{ textField: { fullWidth: true, margin: 'normal' } }}
                      />
                    </LocalizationProvider>
                  </Grid>
                </Grid>

              </Grid>

            </Grid>
          </Box>
        </DialogContent>

        {/* Dialog Actions */}
        <DialogActions sx={{ justifyContent: "space-between", padding: 2 }}>
          <Button variant="outlined" color="error" sx={{ width: 120 }} onClick={() => setOpenAddAttendanceDialog(false)}>CANCEL</Button>
          <Button variant="contained" color="success" sx={{ width: 120 }} onClick={handleSubmitAddAttendance}>SAVE</Button>
        </DialogActions>
      </Dialog>

      {/* POPUP Edit Attendance */}
      <Dialog open={openEditAttendanceDialog} onClose={() => setOpenEditAttendanceDialog(false)} fullWidth maxWidth="lg"
        sx={{ backdropFilter: "blur(5px)", borderRadius: "10px" }}>
        <DialogTitle>
          <Box sx={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
            <Typography variant="h6" fontWeight="bold">Attendance Details</Typography>
            <IconButton onClick={() => setOpenEditAttendanceDialog(false)} color="error"><Close /></IconButton>
          </Box>
        </DialogTitle>

        <DialogContent>
          <Box sx={{ display: "flex", gap: 2, flexWrap: "wrap", mt: 1 }}>
            {/* Left Side (Inputs & Map) */}
            {/* Grid Layout */}
            <Grid container spacing={3}>
              {/* Right Section */}
              <Grid item xs={12} md={4}>

                <TextField
                  fullWidth
                  label="Nomor Induk Karyawan"
                  name="nik"
                  margin="normal"
                  placeholder="Enter NIK"
                  value={editAttendanceData.nik}
                  onChange={(e) => {
                    const nik = e.target.value;
                    const employeeName = employees[nik]?.name || "";
                    const company = employees[nik]?.company || "";
                    const employeeType = employees[nik]?.employeeType || "";
                    setEditAttendanceData({ ...editAttendanceData, nik, employeeName, company, employeeType });
                  }}
                  error={editErrors.nik}
                  helperText={editErrors.nik ? "Mandatory Field" : ""}
                  disabled={!isEditing}
                />
                {editAttendanceData.nik && !employees[editAttendanceData.nik] && (
                  <Typography variant="caption" color="error">
                    NIK tidak ditemukan
                  </Typography>
                )}

                <TextField
                  fullWidth label="Nama Karyawan" name="employeeName" margin="normal"
                  placeholder="Enter employee name" value={editAttendanceData.employeeName}
                  error={editErrors.employeeName}
                  helperText={editErrors.employeeName ? "Mandatory Field" : ""}
                  disabled
                />

                <TextField
                  fullWidth label="Status Karyawan" name="employeeType" margin="normal"
                  placeholder="Enter employee name" value={editAttendanceData.employeeType}
                  disabled
                />
                <TextField
                  fullWidth label="Vendor" name="company" margin="normal"
                  placeholder="Enter employee name" value={editAttendanceData.company}
                  disabled
                />

                <Autocomplete
                  options={officeOptions}
                  getOptionLabel={(option) => option.officeName || ""}
                  value={officeOptions.find(opt => opt.officeName === editAttendanceData.officeLocation) || null}
                  onChange={(event, newValue) => {
                    if (isEditing) {
                      handleEditInputChange({
                        target: {
                          name: "officeLocation",
                          value: newValue ? newValue.officeName : ""
                        }
                      });
                    }
                  }}
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      label="Office Location"
                      placeholder="Select Office"
                      margin="normal"
                      fullWidth
                      disabled={!isEditing}
                      error={editErrors.officeLocation}
                      helperText={editErrors.officeLocation ? "Mandatory Field" : ""}
                    />
                  )}
                />

                <LocalizationProvider dateAdapter={AdapterDayjs}>
                  <DesktopDatePicker
                    label="Select Date"
                    format="YYYY-MM-DD"
                    value={
                      editAttendanceData.attendanceDate
                        ? dayjs(editAttendanceData.attendanceDate)
                        : null
                    }
                    onChange={(newValue) =>
                      handleEditInputChange({
                        target: {
                          name: "attendanceDate",
                          value: newValue
                            ? dayjs(newValue).format("YYYY-MM-DD")
                            : "",
                        },
                      })
                    }
                    disabled={!isEditing}
                    slotProps={{
                      textField: {
                        margin: "normal",
                        fullWidth: true,
                        sx: { mb: 1 },
                        name: "attendanceDate",
                        error: !editAttendanceData.attendanceDate,
                        helperText: !editAttendanceData.attendanceDate
                          ? "Mandatory Field"
                          : "",
                      },
                    }}
                  />
                </LocalizationProvider>
                <TextField
                  select
                  fullWidth label="Status Absensi" name="attendanceStatus" margin="normal"
                  placeholder="Enter Status" value={editAttendanceData.attendanceStatus}
                  onChange={handleEditInputChange} error={editErrors.attendanceStatus}
                  helperText={editErrors.attendanceStatus ? "Mandatory Field" : ""}
                  disabled={!isEditing}
                >
                  <MenuItem value="">Select Attendance Status</MenuItem>

                  <MenuItem key="Presence" value="Presence">
                    Presence
                  </MenuItem>
                  <MenuItem key="Leave" value="Leave">
                    Leave
                  </MenuItem>
                </TextField>
                <TextField
                  fullWidth label="Total Work Hours" name="workHours" margin="normal"
                  placeholder="Enter Work Hours" value={editAttendanceData.workHours}
                  onChange={handleEditInputChange} error={editErrors.workHours}
                  helperText={editErrors.workHours ? "Mandatory Field" : ""}
                  disabled
                />
                <TextField
                  fullWidth label="Total Overtime Hours" name="overtimeHours" margin="normal"
                  placeholder="Enter Overtime Hours" value={editAttendanceData.overtimeHours}
                  onChange={handleEditInputChange}
                  disabled
                />


                {/* <Typography variant="subtitle2" sx={{ mt: 1 }}>Leave</Typography> */}
                <TextField
                  select
                  fullWidth label="Leave Type" name="leaveType" margin="normal"
                  value={editAttendanceData.leaveType}
                  onChange={handleEditInputChange}
                  disabled={!isEditing || !isLeaveEdit}
                >

                  <MenuItem value="" >Select Leave Type</MenuItem>

                  <MenuItem key="Sick Leave" value="Sick Leave">
                    Sick Leave
                  </MenuItem>
                  <MenuItem key="Annual Leave" value="Annual Leave">
                    Annual Leave
                  </MenuItem>
                </TextField>

                <TextField
                  label="Leave Reason"
                  name="leaveReason"
                  value={editAttendanceData.leaveReason}
                  onChange={handleEditInputChange}
                  fullWidth
                  margin="dense"
                  disabled={(!isEditing || !isLeaveEdit)}
                />

                <TextField
                  label="Range"
                  name="range"
                  value={editAttendanceData.range}
                  onChange={handleEditInputChange}
                  fullWidth
                  margin="dense"
                  disabled={!isEditing}
                />
                {/* <TextField
                  fullWidth label="Status Overtime Hours" name="workHours"
                  placeholder="Enter Status" value={editAttendanceData.workHours}
                  onChange={handleEditInputChange} error={editErrors.workHours}
                  helperText={editErrors.workHours ? "Mandatory Field" : ""}
                  disabled={!isEditing}
                /> */}

              </Grid>



              {/* File Upload Section */}
              <Grid item xs={12} md={8}>

                <Grid container spacing={1} alignItems="center" sx={{ mb: 1 }}>
                  <Grid item xs={6}>
                    <Box
                      sx={{
                        flex: 1,
                        display: "flex",
                        flexDirection: "column",
                        alignItems: "center",
                        justifyContent: "center",
                        border: "2px dashed #aaa",
                        padding: 4,
                        borderRadius: "12px",
                        backgroundColor: "#fafafa",
                        textAlign: "center",
                        cursor: "pointer",
                        position: "relative",
                        height: "200px",
                      }}
                      // disabled={!isEditing}
                      onDragOver={(e) => e.preventDefault()}
                      onDrop={(e) => {
                        if (isEditing) {
                          e.preventDefault();
                          const file = e.dataTransfer.files[0];
                          handleEditFileUpload({ fileCIn: file });
                        }
                      }}
                      onClick={() => {
                        if (isEditing) {
                          editCInFileInputRef.current?.click()
                        }
                      }}
                    >
                      {editAttendanceData.fileCIn ? (
                        // Jika user baru upload gambar
                        <img
                          src={URL.createObjectURL(editAttendanceData.fileCIn)}
                          alt="Preview"
                          style={{
                            width: "100%",
                            height: "auto",
                            borderRadius: "8px",
                            objectFit: "contain",
                            maxHeight: 180,
                          }}
                        />
                      ) : editAttendanceData.previewUrlCIn ? (
                        // Jika sudah ada foto dari server
                        <img
                          src={editAttendanceData.previewUrlCIn}
                          alt="Existing"
                          style={{
                            width: "100%",
                            height: "auto",
                            borderRadius: "8px",
                            objectFit: "contain",
                            maxHeight: 180,
                          }}
                        />
                      ) : (
                        // Jika tidak ada gambar sama sekali
                        <>
                          <PhotoCamera fontSize="large" />
                          <Typography variant="body2" color="textSecondary" mt={1}>
                            Drag & drop or click to upload image
                          </Typography>
                        </>
                      )}
                      <input
                        hidden
                        accept="image/png, image/jpeg, image/jpg"
                        type="file"
                        ref={editCInFileInputRef}
                        onChange={(e) => handleEditFileUpload({ fileCIn: e.target.files[0] })}
                      />
                      <Typography variant="caption" mt={1}>
                        Max size: 5MB (.png, .jpg, .jpeg)
                      </Typography>
                    </Box>
                    <LocalizationProvider dateAdapter={AdapterDayjs}>
                      <TimePicker
                        label="Checkin Time"
                        ampm={false}
                        value={editAttendanceData.checkinTime ? dayjs(editAttendanceData.checkinTime, 'HH:mm') : null}
                        onChange={(newValue) =>
                          setEditAttendanceData({ ...editAttendanceData, checkinTime: newValue?.format('HH:mm:ss') || '' })
                        }
                        name="checkinTime"
                        className="timePicker"
                        minutesStep={1}
                        disabled={!isEditing}
                        slotProps={{ textField: { fullWidth: true, margin: 'normal' } }}
                      />
                    </LocalizationProvider>
                  </Grid>
                  <Grid item xs={6}>
                    <Box
                      sx={{
                        flex: 1,
                        display: "flex",
                        flexDirection: "column",
                        alignItems: "center",
                        justifyContent: "center",
                        border: "2px dashed #aaa",
                        padding: 4,
                        borderRadius: "12px",
                        backgroundColor: "#fafafa",
                        textAlign: "center",
                        cursor: "pointer",
                        position: "relative",
                        height: "200px",
                      }}
                      disabled={!isEditing}
                      onDragOver={(e) => e.preventDefault()}
                      onDrop={(e) => {
                        if (isEditing) {
                          e.preventDefault();
                          const file = e.dataTransfer.files[0];
                          handleEditFileUpload({ fileCOut: file });
                        }
                      }}
                      onClick={() => {
                        if (isEditing) {
                          editCOutFileInputRef.current?.click()
                        }
                      }}
                    >
                      {editAttendanceData.fileCOut ? (
                        // Jika user baru upload gambar
                        <img
                          src={URL.createObjectURL(editAttendanceData.fileCOut)}
                          alt="Preview"
                          style={{
                            width: "100%",
                            height: "auto",
                            borderRadius: "8px",
                            objectFit: "contain",
                            maxHeight: 180,
                          }}
                        />
                      ) : editAttendanceData.previewUrlCOut ? (
                        // Jika sudah ada foto dari server
                        <img
                          src={editAttendanceData.previewUrlCOut}
                          alt="Existing"
                          style={{
                            width: "100%",
                            height: "auto",
                            borderRadius: "8px",
                            objectFit: "contain",
                            maxHeight: 180,
                          }}
                        />
                      ) : (
                        // Jika tidak ada gambar sama sekali
                        <>
                          <PhotoCamera fontSize="large" />
                          <Typography variant="body2" color="textSecondary" mt={1}>
                            Drag & drop or click to upload image
                          </Typography>
                        </>
                      )}
                      <input
                        hidden
                        accept="image/png, image/jpeg, image/jpg"
                        type="file"
                        ref={editCOutFileInputRef}
                        onChange={(e) => handleEditFileUpload({ fileCOut: e.target.files[0] })}
                      />
                      <Typography variant="caption" mt={1}>
                        Max size: 5MB (.png, .jpg, .jpeg)
                      </Typography>
                    </Box>
                    <LocalizationProvider dateAdapter={AdapterDayjs}>
                      <TimePicker
                        label="Checkout Time"
                        ampm={false}
                        value={editAttendanceData.checkoutTime ? dayjs(editAttendanceData.checkoutTime, 'HH:mm') : null}
                        onChange={(newValue) =>
                          setEditAttendanceData({ ...editAttendanceData, checkoutTime: newValue?.format('HH:mm:ss') || '' })
                        }
                        name="checkoutTime"
                        className="timePicker"
                        minutesStep={1}
                        slotProps={{ textField: { fullWidth: true, margin: 'normal' } }}
                        disabled={!isEditing}
                      />
                    </LocalizationProvider>
                  </Grid>
                  <Grid item xs={6}>

                    <Box
                      sx={{
                        flex: 1,
                        display: "flex",
                        flexDirection: "column",
                        alignItems: "center",
                        justifyContent: "center",
                        border: "2px dashed #aaa",
                        padding: 4,
                        borderRadius: "12px",
                        backgroundColor: "#fafafa",
                        textAlign: "center",
                        cursor: "pointer",
                        position: "relative",
                        height: "200px",
                      }}
                      // disabled={!isEditing}
                      onDragOver={(e) => e.preventDefault()}
                      onDrop={(e) => {
                        if (isEditing) {
                          e.preventDefault();
                          const file = e.dataTransfer.files[0];
                          handleEditFileUpload({ fileOIn: file });
                        }
                      }}
                      onClick={() => {
                        if (isEditing) {
                          editOInFileInputRef.current?.click()
                        }
                      }}
                    >
                      {editAttendanceData.fileOIn ? (
                        // Jika user baru upload gambar
                        <img
                          src={URL.createObjectURL(editAttendanceData.fileOIn)}
                          alt="Preview"
                          style={{
                            width: "100%",
                            height: "auto",
                            borderRadius: "8px",
                            objectFit: "contain",
                            maxHeight: 180,
                          }}
                        />
                      ) : editAttendanceData.previewUrlOIn ? (
                        // Jika sudah ada foto dari server
                        <img
                          src={editAttendanceData.previewUrlOIn}
                          alt="Existing"
                          style={{
                            width: "100%",
                            height: "auto",
                            borderRadius: "8px",
                            objectFit: "contain",
                            maxHeight: 180,
                          }}
                        />
                      ) : (
                        // Jika tidak ada gambar sama sekali
                        <>
                          <PhotoCamera fontSize="large" />
                          <Typography variant="body2" color="textSecondary" mt={1}>
                            Drag & drop or click to upload image
                          </Typography>
                        </>
                      )}
                      <input
                        hidden
                        accept="image/png, image/jpeg, image/jpg"
                        type="file"
                        ref={editOInFileInputRef}
                        onChange={(e) => handleEditFileUpload({ fileOIn: e.target.files[0] })}
                      />
                      <Typography variant="caption" mt={1}>
                        Max size: 5MB (.png, .jpg, .jpeg)
                      </Typography>
                    </Box>
                    <LocalizationProvider dateAdapter={AdapterDayjs}>
                      <TimePicker
                        label="Overtime In"
                        ampm={false}
                        value={editAttendanceData.overtimeIn ? dayjs(editAttendanceData.overtimeIn, 'HH:mm') : null}
                        onChange={(newValue) =>
                          setEditAttendanceData({ ...editAttendanceData, overtimeIn: newValue?.format('HH:mm:ss') || '' })
                        }
                        name="overtimeIn"
                        className="timePicker"
                        minutesStep={1}
                        slotProps={{ textField: { fullWidth: true, margin: 'normal' } }}
                        disabled={!isEditing}
                      />
                    </LocalizationProvider>
                  </Grid>
                  <Grid item xs={6}>

                    <Box
                      sx={{
                        flex: 1,
                        display: "flex",
                        flexDirection: "column",
                        alignItems: "center",
                        justifyContent: "center",
                        border: "2px dashed #aaa",
                        padding: 4,
                        borderRadius: "12px",
                        backgroundColor: "#fafafa",
                        textAlign: "center",
                        cursor: "pointer",
                        position: "relative",
                        height: "200px",
                      }}
                      // disabled={!isEditing}
                      onDragOver={(e) => e.preventDefault()}
                      onDrop={(e) => {
                        if (isEditing) {
                          e.preventDefault();
                          const file = e.dataTransfer.files[0];
                          handleEditFileUpload({ fileOOut: file });
                        }
                      }}
                      onClick={() => {
                        if (isEditing) {
                          editOOutFileInputRef.current?.click()
                        }
                      }}
                    >
                      {editAttendanceData.fileOOut ? (
                        // Jika user baru upload gambar
                        <img
                          src={URL.createObjectURL(editAttendanceData.fileOOut)}
                          alt="Preview"
                          style={{
                            width: "100%",
                            height: "auto",
                            borderRadius: "8px",
                            objectFit: "contain",
                            maxHeight: 180,
                          }}
                        />
                      ) : editAttendanceData.previewUrlOOut ? (
                        // Jika sudah ada foto dari server
                        <img
                          src={editAttendanceData.previewUrlOOut}
                          alt="Existing"
                          style={{
                            width: "100%",
                            height: "auto",
                            borderRadius: "8px",
                            objectFit: "contain",
                            maxHeight: 180,
                          }}
                        />
                      ) : (
                        // Jika tidak ada gambar sama sekali
                        <>
                          <PhotoCamera fontSize="large" />
                          <Typography variant="body2" color="textSecondary" mt={1}>
                            Drag & drop or click to upload image
                          </Typography>
                        </>
                      )}
                      <input
                        hidden
                        accept="image/png, image/jpeg, image/jpg"
                        type="file"
                        ref={editOOutFileInputRef}
                        onChange={(e) => handleEditFileUpload({ fileOOut: e.target.files[0] })}
                      />
                      <Typography variant="caption" mt={1}>
                        Max size: 5MB (.png, .jpg, .jpeg)
                      </Typography>
                    </Box>
                    <LocalizationProvider dateAdapter={AdapterDayjs}>
                      <TimePicker
                        label="Overtime Out"
                        ampm={false}
                        value={editAttendanceData.overtimeOut ? dayjs(editAttendanceData.overtimeOut, 'HH:mm') : null}
                        onChange={(newValue) =>
                          setEditAttendanceData({ ...editAttendanceData, overtimeOut: newValue?.format('HH:mm:ss') || '' })
                        }
                        name="overtimeOut"
                        className="timePicker"
                        minutesStep={1}
                        slotProps={{ textField: { fullWidth: true, margin: 'normal' } }}
                        disabled={!isEditing}
                      />
                    </LocalizationProvider>
                  </Grid>
                </Grid>

              </Grid>

            </Grid>
          </Box>
        </DialogContent>

        {/* Dialog Actions */}
        <DialogActions sx={{ justifyContent: "space-between", padding: 2 }}>
          {!isEditing ? (
            // Tombol Edit Muncul di Awal
            <Button onClick={() => setIsEditing(true)} variant="contained" color="primary" sx={{ width: 120 }}>
              EDIT
            </Button>
          ) : (
            // Tombol Save & Cancel Muncul Saat Edit
            <>
              <Button onClick={() => setIsEditing(false)} variant="outlined" color="error" sx={{ width: 120 }}>
                CANCEL
              </Button>
              <Button onClick={handleSubmitEditAttendance} variant="contained" color="success" sx={{ width: 120 }}>
                SAVE
              </Button>
            </>
          )}
        </DialogActions>
      </Dialog>


      {/* ======================= Filter Dialog ============================= */}
      <Dialog open={openFilterDialog} onClose={() => setOpenFilterDialog(false)}>
        <DialogTitle>Advanced Search</DialogTitle>
        <DialogContent>
          {/* Field Tetap: attendanceDate */}
          <Box display="flex" alignItems="center" gap={1} mb={2}>
            {/* <TextField
              select
              value="Tanggal"
              disabled
              variant="outlined"
              size="small"
              sx={{ mt: 1, minWidth: 160 }}
            >

              <MenuItem value="Tanggal">
                Tanggal
              </MenuItem>

            </TextField> */}


            <LocalizationProvider dateAdapter={AdapterDayjs}>
              <DesktopDatePicker
                label="Start Date"
                format="YYYY-MM-DD"
                value={startDate ? dayjs(startDate) : null}
                onChange={(newValue) =>
                  setStartDate(newValue ? newValue.format("YYYY-MM-DD") : null)
                }
                slotProps={{
                  textField: {
                    variant: "outlined",
                    size: "small",
                    sx: { mt: 1, minWidth: 150 },
                  },
                }}
              />
            </LocalizationProvider>

            <LocalizationProvider dateAdapter={AdapterDayjs}>
              <DesktopDatePicker
                label="End Date"
                format="YYYY-MM-DD"
                value={endDate ? dayjs(endDate) : null}
                onChange={(newValue) =>
                  setEndDate(newValue ? newValue.format("YYYY-MM-DD") : null)
                }
                slotProps={{
                  textField: {
                    variant: "outlined",
                    size: "small",
                    sx: { mt: 1, minWidth: 150 },
                  },
                }}
              />
            </LocalizationProvider>

          </Box>

          {/* Field Dinamis */}
          {filters.map((filter, index) => {
            const usedFields = filters.map((f, i) => i !== index && f.field).filter(Boolean);
            const availableOptions = availableFilters.filter((opt) => !usedFields.includes(opt.value));
            const statusOptions = ["Valid", "Not Valid", "Leave"];
            return (
              <Box key={index} display="flex" alignItems="center" gap={1} mb={2}>
                <TextField
                  select
                  value={filter.field}
                  onChange={(e) => handleFilterChange(index, "field", e.target.value)}
                  variant="outlined"
                  size="small"
                  sx={{ mt: 1, minWidth: 160 }}
                >
                  {availableOptions.map((option) => (
                    <MenuItem key={option.value} value={option.value}>
                      {option.label}
                    </MenuItem>
                  ))}
                </TextField>

                {filter.field === "attendanceStatus" ? (
                  <TextField
                    select
                    label="Attendance Status"
                    variant="outlined"
                    size="small"
                    value={filter.value}
                    onChange={(e) =>
                      handleFilterChange(index, "value", e.target.value)
                    }
                    sx={{ mt: 1, minWidth: 160 }}
                  >
                    {statusOptions.map((option) => (
                      <MenuItem key={option} value={option}>
                        {option}
                      </MenuItem>
                    ))}
                  </TextField>
                ) : filter.field === "officeLocation" ? (
                  // <TextField
                  //   select
                  //   label="Office Location"
                  //   variant="outlined"
                  //   size="small"
                  //   value={filter.value}
                  //   onChange={(e) =>
                  //     handleFilterChange(index, "value", e.target.value)
                  //   }
                  //   sx={{ mt: 1, minWidth: 160 }}
                  // >
                  //   {officeOptions.map((option) => (
                  //     <MenuItem key={option.officeName} value={option.officeName}>
                  //       {option.officeName}
                  //     </MenuItem>
                  //   ))}
                  // </TextField>
                  <FormControl fullWidth margin="dense">
                    <Autocomplete
                      size="small"
                      options={officeOptions}
                      getOptionLabel={(option) => option.officeName || ""}
                      value={officeOptions.find(opt => opt.officeName === filter.value) || null}
                      onChange={async (event, newValue) => {
                        const selOfficeName = await newValue ? newValue.officeName : ""
                        await handleFilterChange(index, "value", selOfficeName);

                      }}
                      renderInput={(params) => (
                        <TextField
                          {...params}
                          label="Office Location"
                          placeholder="Select Office"
                          margin="dense"
                          fullWidth
                        />
                      )}
                    />


                  </FormControl>
                ) : filter.field === "vendorId" ? (
                  <FormControl fullWidth margin="dense">
                    <Autocomplete
                      size="small"
                      options={vendors}
                      getOptionLabel={(option) => option.vendorName || ""}
                      value={vendors.find(opt => opt.vendorId === filter.value) || null}
                      onChange={async (event, newValue) => {
                        const selVendor = await newValue ? newValue.vendorId : ""
                        // console.log(newValue,selVendor)
                        await handleFilterChange(index, "value", selVendor);

                      }}
                      renderInput={(params) => (
                        <TextField
                          {...params}
                          label="Vendor"
                          placeholder="Select Vendor"
                          margin="dense"
                          fullWidth
                        />
                      )}
                    />


                  </FormControl>
                ) : (
                  <TextField
                    label="Value"
                    variant="outlined"
                    size="small"
                    value={filter.value}
                    onChange={(e) =>
                      handleFilterChange(index, "value", e.target.value)
                    }
                    sx={{ mt: 1 }}
                  />
                )}

                {index > 0 && (
                  <IconButton onClick={() => handleRemoveFilter(index)}>
                    <Remove />
                  </IconButton>
                )}
              </Box>
            );
          })}

          {filters.length < availableFilters.length && (
            <Button startIcon={<Add />} onClick={handleAddFilter}>
              Add Filter
            </Button>
          )}
        </DialogContent>
        <DialogActions>
          <Button onClick={handleResetFilters}>Reset Filter</Button>
          <Button onClick={handleCloseFilter}>Cancel</Button>
          <Button variant="contained" onClick={handleApplyFilters} disabled={isLoading}>
            {isLoading ? "Loading..." : "Apply"}
          </Button>
        </DialogActions>
      </Dialog>




    </Box>
  );
};

export default AttendanceListPage;
